export default __webpack_public_path__ + "static/media/img21.adfc2f2a.png";